
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable,AppAction} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {HouseOutput} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : "P0231-01-023",
    formdata:{posId:''},
    labelWidth:100 ,
    items:
    [
        {lable:'楼栋PosId',field:'posId',placeholder:'string类型:输入楼栋的posId'}
    ]
};

let outputExample = [
    {
        aofyname: '房源名称',
        ponum: '房源编码',
        zfjnm: '税率',
        zsl: '税码',
        zsm: '房间单元名',
        zszdy: '房间房号'
    }
 ] as HouseOutput[]

export const AppGetHouse = () =>{

    const[outputResult,setOutputResult]  = useState([] as HouseOutput[])
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        AppAction.coverFull();
        let res = await api.public.possap.getHouseListByPosId(inputParam);
        setOutputResult(res);
        AppAction.cancelCoverFull();
    }

    const renderOutput = () =>{
        console.log('outputResult:',outputResult)
        if(outputResult===null) return '';

        switch(outputView){
            case 0:
            return <RoomTable list={outputResult}/>;
        }

        return  <pre>{JSON.stringify(outputResult, null, 4)}</pre>;
    }
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>SAP获取房间列表</h1>    
            <div>
                1、调用SAP接口获取SAP房源数据<br/>
                2、参数为楼栋id（POSID） <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['房间列表','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>
    </div>)
}


const RoomTable = (props:{list:any[]}) =>{
    return ( <AppTable  dataSource={props.list}>
        <AppTable.ColIndex />
        <AppTable.Col field='aofyname' title='房源名称'  width={200}/>
        <AppTable.Col field='ponum' title='房源编码' width={100}/>
        <AppTable.Col field='zfjnm' title='税率' width={100}/>
        <AppTable.Col field='zsl' title='税码' width={100}/>
        <AppTable.Col field='zsm' title='房间单元名' width={100}/>
        <AppTable.Col field='zszdy' title='房间房号' width={100}/>
     </AppTable>)
}


// WEBPACK FOOTER //
// ./src/posapi/sap/AppGetHouse.tsx